import { useState } from 'react';
import { useVerticalTabsContext } from 'further-ui/components/VerticalTabsContext';

export const useVerticalTabs = <T extends string>(initial: T) => {
  // can either use the context or local state
  const context = useVerticalTabsContext();
  const [selectedTab, setSelectedTab] = useState<T>(initial);

  return {
    selectedTab: (context?.verticalTab as T | undefined) ?? selectedTab,
    setSelectedTab: (tab: T) => {
      setSelectedTab(tab);
      context?.setVerticalTab(tab);
    },
  };
};
